import { render } from "./Layout1.vue?vue&type=template&id=c8da8f4c&scoped=true&ts=true"
import script from "./Layout1.vue?vue&type=script&lang=ts"
export * from "./Layout1.vue?vue&type=script&lang=ts"

import "./Layout1.vue?vue&type=style&index=0&id=c8da8f4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8da8f4c"]])

export default __exports__